import styled from "styled-components";

const PluginHeader = styled.h2.attrs({
  className: "mt4 mb1"
})`
  color: #222222;
  font-size: 22px;
  letter-spacing: 0.02px;
  line-height: 32px;

  .spot-number {
    display: inline-block;
    background-color: green;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    font-size: 16px;
    line-height: 32px;
    color: white;
    text-align: center;
  }
`;

export default PluginHeader;
